import { useEffect, useState } from 'react';

import { AccountUserDto } from '@/api/generated';
import useUsers from '@/hooks/useUsers';

interface UseUsersEmailsProps {
  participants?: Array<{
    email?: string;
  }>;
  selectedEmail?: string;
}

const useUsersEmails = ({ participants, selectedEmail }: UseUsersEmailsProps) => {
  const { usersList: organizationUsers } = useUsers();
  const [users, setUsers] = useState<AccountUserDto[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<AccountUserDto[]>([]);

  useEffect(() => {
    if (participants || organizationUsers) {
      const emailsSet = new Set<string>();
      participants?.forEach(participant => {
        if (participant.email) {
          emailsSet.add(participant.email);
        }
      });

      organizationUsers?.forEach(user => {
        if (user.email) {
          emailsSet.add(user.email);
        }
      });

      const usersList = Array.from(emailsSet).map(email => ({
        id: email,
        email
      }));
      if (selectedEmail) {
        const sortedUsers = usersList.sort((a, b) => {
          if (a.email === selectedEmail) return -1;
          if (b.email === selectedEmail) return 1;
          return 0;
        });
        setUsers(sortedUsers);

        const senderIndex = usersList.findIndex(user => user.email === selectedEmail);
        setSelectedUsers([usersList[senderIndex]]);
      } else {
        setUsers(usersList);
      }
    }
  }, [participants, organizationUsers, selectedEmail]);

  return {
    users,
    selectedUsers,
    setSelectedUsers
  };
};

export default useUsersEmails;
